import { mapGetters, mapMutations } from 'vuex';
import { FormField, FormInput, Alert } from '@/components';
import { AccessLevel, OperationType } from '@/enums';
import { VUEX_GENERAL, VUEX_PAYMENT_DETAILS } from '@/constants/VuexConstants';
import { getAccessLevel } from '@/utils';
import { PaymentMethods, RelationshipValue } from '@general/js/enums';

export default {
  components: {
    FormField,
    FormInput,
    Alert,
  },
  data() {
    return {
      AccessLevel,
      OperationType,
    };
  },
  mounted() {
    if (this.v$) {
      this.updatePaymentDetailsFormValid(this.v$.$invalid);
      this.$emit('updateStepValidation', this.v$.$invalid, this.$options.name);
    }
  },
  computed: {
    ...mapGetters({
      currentMemberDetail: VUEX_GENERAL.GETTERS.getCurrentMemberDetails,
      currentPolicyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      isAutoLogout: VUEX_GENERAL.GETTERS.getLogoutState,
      currentPersonCode: VUEX_GENERAL.GETTERS.getCurrentPersonCode,
      memberships: VUEX_GENERAL.GETTERS.memberships,
      membershipInfo: VUEX_GENERAL.GETTERS.getMembershipInfo,
      allMembers: VUEX_GENERAL.GETTERS.getMembers,
    }),
    ...mapGetters('PaymentDetails', {
      pageNumber: VUEX_PAYMENT_DETAILS.GETTERS.getPaymentDetailsPageNum,
      paymentDetails: VUEX_PAYMENT_DETAILS.GETTERS.getPaymentDetails,
      refData: VUEX_PAYMENT_DETAILS.GETTERS.getPaymentDetailsPageReferenceData,
      isInvalid: VUEX_PAYMENT_DETAILS.GETTERS.getPaymentDetailsFormValidationStatus,
      hasFormBeenUpdated: VUEX_PAYMENT_DETAILS.GETTERS.getHasFormBeenUpdated,
      finishedUpdatingDetails: VUEX_PAYMENT_DETAILS.GETTERS.getSubmitUpdateSuccessfulStatus,
      submitPolicyInProcess: VUEX_PAYMENT_DETAILS.GETTERS.getSubmitPolicyInProcess,
    }),
    memberFullName() {
      return `${this.selectedMember?.firstName} ${this.selectedMember?.lastName}`;
    },
    isPremiumAccountOfTypeBank() {
      return this.paymentDetails?.premiumPaymentAccount?.accountType === PaymentMethods.BANK_ACCOUNT;
    },
    isPremiumAccountOfTypeCreditCard() {
      return this.paymentDetails?.premiumPaymentAccount?.accountType === PaymentMethods.CREDIT_CARD;
    },
    isPolicyHolderDetails() {
      return this.selectedMember?.coveredOnMembership?.toLowerCase() === RelationshipValue.POLICY_HOLDER.toLowerCase();
    },
    isLimitedAccessMember() {
      return this.selectedMember?.accessLevel?.toLowerCase() === AccessLevel.LIMITED_ACCESS;
    },
  },
  methods: {
    ...mapMutations('PaymentDetails', {
      updatePaymentDetailsInfo: VUEX_PAYMENT_DETAILS.MUTATIONS.updatePaymentDetailsInfo,
      updatePaymentDetailsPageNum: VUEX_PAYMENT_DETAILS.MUTATIONS.updatePaymentDetailsPageNum,
      updatePaymentDetailsFormValid: VUEX_PAYMENT_DETAILS.MUTATIONS.updatePaymentDetailsFormValid,
      updatePaymentDetailsRefData: VUEX_PAYMENT_DETAILS.MUTATIONS.updatePaymentDetailsRefData,
      updateSubmitUpdateSuccessful: VUEX_PAYMENT_DETAILS.MUTATIONS.updateSubmitUpdateSuccessful,
      resetPaymentDetails: VUEX_PAYMENT_DETAILS.MUTATIONS.resetPaymentDetails,
      updateSubmitPolicyInProcess: VUEX_PAYMENT_DETAILS.MUTATIONS.updateSubmitPolicyInProcess,
    }),
    addRequiredMark(informationText) {
      return `${informationText.replace('</p>', '')} <span class="required-input">*</span></p>`;
    },
    accessLevel(policyNumber) {
      return getAccessLevel(policyNumber, this.memberships);
    },
    formatCreditCardExpiryDDMM(date) {
      // date is in YYY-MM-DD format
      if (date) {
        let expiryDate = date.split('-');
        expiryDate = `${expiryDate[1]} / ${expiryDate[0].slice(2)}`;
        return expiryDate;
      }
      return '';
    },
  },

  watch: {
    'v$.$invalid': function (newVal) {
      this.updatePaymentDetailsFormValid(newVal);
      this.$emit('updateStepValidation', this.v$.$invalid, this.$options.name);
    },

    'v$.$error': function (newVal) {
      this.updatePaymentDetailsFormValid(newVal);
    },
  },

  created() {
    this.$watch(
      () => this.v$?.paymentDetails?.$model,
      (newVal) => {
        if (newVal !== undefined) {
          this.updatePaymentDetailsInfo(newVal);
        }
      },
      { deep: true },
    );
  },
};
